import { render, staticRenderFns } from "./MenuTarefas.vue?vue&type=template&id=5f633fc2&"
import script from "./MenuTarefas.vue?vue&type=script&lang=js&"
export * from "./MenuTarefas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports